// extracted by mini-css-extract-plugin
export default {"container":"home-screen_container__+JS6g","title":"home-screen_title__R8moi","description":"home-screen_description__iz23M"};